function relatedProductsSlider() {
    $('.related-products-slider').each(function () {
        $(this).slick({
            arrows: true,
            dots: false,
            slide: '.related-product-slide',
            slidesToShow: 3,
            swipeToSlide: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    });
}

jQuery(window).load(function () {
    relatedProductsSlider();
});
